module.exports = __webpack_public_path__ + "static/media/icon-calendar.936d754e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-calendar.svg
// module id = 1240
// module chunks = 19